import { render, staticRenderFns } from "./FullCalendarEvent.vue?vue&type=template&id=7542aef2&scoped=true"
import script from "./FullCalendarEvent.vue?vue&type=script&lang=js"
export * from "./FullCalendarEvent.vue?vue&type=script&lang=js"
import style0 from "./FullCalendarEvent.vue?vue&type=style&index=0&id=7542aef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7542aef2",
  null
  
)

export default component.exports